import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import KenColors from "../../Helpers/Themes/kenColors";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    height: "100vh",
    width: "100%",
    overflow: "hidden",
  },
  headerTitle: {
    fontSize: "44px !important",
    fontWeight: "800 !important",
    color: "#fff !important",
    letterSpacing: "0.44px",
    fontStyle: "italic",
  },
  headerTitle2: {
    // marginTop: "-10px !important",
    fontSize: "44px !important",
    fontWeight: "800 !important",
    fontStyle: "italic",
    background: "linear-gradient(90deg, #E07E27 -22.62%, #E93301 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    letterSpacing: "0.44px",
    lineHeight: "47px !important",
  },
  headerDescription: {
    fontSize: "16px !important",
    fontWeight: "300 !important",
    color: "#fff",
  },
  hintTypo: {
    fontSize: "16px !important",
    fontWeight: "300 !important",
    color: "#919191",
  },
  phoneInputContainer: {
    width: "100%",
    marginTop: "48px",
  },
  phoneInputContainer2: {
    width: "100%",
    marginTop: "48px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    // justifyContent: "center",
  },
  phoneInput: {
    width: "100% !important",
    height: "52px !important",
    background: "#0D0D0D !important",
    color: "#fff !important",
    border: "0.5px solid transparent !important",
    borderRadius: "8px !important",
    fontSize: "18px !important",
    paddingLeft: "50px !important",
    outline: "none",
    transition: "border 0.3s ease-in-out",
  },
  phoneInputWrapper: {
    display: "flex",
    alignItems: "center",
    borderRadius: "8px",
    position: "relative",
    border: "0.5px solid #E35C16",
    backgroundColor: "#000",
    width: "calc(100% - 10px) !important",
    // maxWidth: "400px",
    padding: "5px",
    boxShadow: "0px 4px 30px 0px rgba(227, 92, 22, 0.30)",
  },
  phoneDropdown: {
    background: "transparent !important",
    border: "none !important",
    color: "#fff !important",
    paddingLeft: "10px !important",
  },
  phoneDropdownList: {
    background: "#1a1a1a !important",
    color: "#fff !important",
  },
  otpButton: {
    width: "100%",
    height: "56px !important",
    fontSize: "18px !important",
    fontWeight: "600 !important",
    borderRadius: "60px !important",
  },
  otpContainerCard: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "10px 2px",
    marginBottom: "10px",
    height: "maxContent",
    backgroundColor: "inherit !important",
    [theme.breakpoints.down("ultraHD")]: {
      padding: "2px 2px",
      marginBottom: "10px",
    },
  },
  otpInputStyle: {
    border: `1px solid #E35C16`,
    borderRadius: "8px !important",
    width: "60px !important",
    height: "60px !important",
    fontSize: "16px !important",
    margin: "0 24px 0px 0px",
    textAlign: "center",
    justifyContent: "center",
    fontWeight: "400 !important",
    color: "#E35C16 !important",
    backgroundColor: "#101010 !important",
    [theme.breakpoints.down("ultraHD")]: {
      width: "45px !important",
      height: "45px !important",
      borderRadius: "6px !important",
      fontSize: "12px !important",
    },
    [theme.breakpoints.down("fullHD")]: {
      width: "48px !important",
      height: "48px !important",
      borderRadius: "6px !important",
    },
    [theme.breakpoints.down("xxl")]: {
      width: "48px !important",
      height: "48px !important",
      borderRadius: "6px !important",
    },
  },
  resend: {
    border: "none",
    fontSize: "14px !important",
    fontWeight: "500 !important",
    color: `#E35C16 !important`,
    cursor: "pointer",
    marginTop: "10px !important",
    marginRight: "20px !important",
  },
}));

export const otpContainerStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderColor: `#000`,
  outline: `#000`,
  width: "100%",
} as React.CSSProperties;
